import { Injectable } from '@nestjs/common';
import { AssetsActionControl } from './asset-action-control.entity';
import { AssetActionControlRepository } from './asset-action-control.repository';
import { AssetActionControlRequest } from './dto/asset-action-control.dto';
import { JobManagementApiService } from '@gtpl/shared-services/job-management-api';
import moment from "moment";
import { AssetActivityControlRequest } from '@gtpl/shared-models/common-models';
import { SoakingMainDashboardModel } from '@gtpl/shared-models/asset-management';
import { AssetCodeDto } from './dto/asset-code.dto';
import { AssetControlRequest } from './dto/asset-control.req';
import appSettings from 'apps/services/config';
import { getManager } from 'typeorm';
import { CommonResponse } from '@gtpl/shared-models/masters';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';

@Injectable()
export class AssetActionControlService {
    constructor(
      private logService:LogsService,

        private assetsRepository: AssetActionControlRepository,
        private jobManagementApi: JobManagementApiService
        
        ) {}

    async saveAssetAction(dtoObj: AssetActionControlRequest): Promise<CommonResponse> {
        const existingAssetData = await this.assetsRepository.findOne({where:{assetCode:dtoObj.assetCode,assetStatus:true}, order:{createdAt: "DESC"}});
        const existingTubData = await this.assetsRepository.findOne({where:{tubCode:dtoObj.tubCode,tubStatus:true}, order:{createdAt: "DESC"}});
        if(existingAssetData || existingTubData){
            return new CommonResponse(false,5555,'Tub/Asset is in running Status')
        }
        const entityObj = new AssetsActionControl();
        entityObj.assetCode = dtoObj.assetCode;
        entityObj.assetControl = dtoObj.assetControl;
        entityObj.createdUser = dtoObj.createdUser;
        entityObj.cronJobTime = dtoObj.cronJobTime;
        entityObj.tubCode = dtoObj.tubCode;
        entityObj.durationOne = dtoObj.durationOne;
        entityObj.durationTwo = dtoObj.durationTwo;
        entityObj.assetStatus = true;
        entityObj.tubStatus = true;
        entityObj.unitId = dtoObj.unitId
        console.log(entityObj)

        const assetTrackSave = await this.assetsRepository.save(entityObj);
        if (assetTrackSave.assetsActionControlId) {
            const reqObj = new AssetActivityControlRequest();
            reqObj.assetCode = dtoObj.assetCode;
            reqObj.tubCode = dtoObj.tubCode;
            reqObj.assetControl = dtoObj.assetControl;
            reqObj.createdUser = dtoObj.createdUser;
            reqObj.cronJobTime = dtoObj.cronJobTime;
            reqObj.date = dtoObj.date;
            reqObj.jobId = dtoObj.jobId;
            //need to be uncommented if smart plug integration will use
            // await this.jobManagementApi.controlSmartPlug();
            // await this.jobManagementApi.triggerJobForAssetActivity(reqObj);
            return new CommonResponse(false,5555,'Asset Started Successfully')
        } else {
            return new CommonResponse(false,5555,'Something Went Wrong')
        }
    }

    async getLatestActionOfAsset(reqObj: AssetCodeDto): Promise<AssetActionControlRequest> {
        let statuscolumnName
        let codecolumnName
        if(reqObj.codeType == 'assetCode'){
            statuscolumnName = 'assetStatus'
        }
        if(reqObj.codeType == 'tubCode'){
            statuscolumnName = 'tubStatus'
        }
        if(reqObj.codeType == 'assetCode'){
            codecolumnName = 'assetCode'
        }
        if(reqObj.codeType == 'tubCode'){
            codecolumnName = 'tubCode'
        }
        const entityObj = await this.assetsRepository.findOne({where:{[codecolumnName]:reqObj.assetCode,[statuscolumnName]:true}, order:{createdAt: "DESC"}});
        if (entityObj) {
            const dtoObj = new AssetActionControlRequest();
            dtoObj.assetCode = entityObj.assetCode;
            dtoObj.assetControl = entityObj.assetControl;
            dtoObj.createdUser = entityObj.createdUser;
            dtoObj.cronJobTime = entityObj.cronJobTime;
            dtoObj.date = moment(entityObj.createdAt).format('YYYY-MM-DD HH:MM');
            dtoObj.jobId = entityObj.assetCode;
            return dtoObj;
        } else {
            return null;
        }  
    }

    async getSoakingMachineDashboardData():Promise<CommonResponse>{
        try{
            // const entityObj : AssetsActionControl[]= await this.assetsRepository.find({ order:{createdAt: "DESC"}});
            // console.log(entityObj)
            // if (entityObj) {
            //     const sokingDashboardData : SoakingMainDashboardModel[] = []
            //     for(const i of entityObj){
            //         const dtoObj = new SoakingMainDashboardModel();
            //         dtoObj.assetCode = i.assetCode;
            //         dtoObj.assetControl = i.assetControl;
            //         dtoObj.createdUser = i.createdUser;
            //         dtoObj.cronJobTime = i.cronJobTime;
            //         dtoObj.date = moment(i.createdAt).format('YYYY-MM-DD HH:MM');
            //         dtoObj.jobId = i.assetCode;
            //         sokingDashboardData.push(dtoObj)
            //     }
            //     return new CommonResponse(true,11111,'Data retreived successfully',sokingDashboardData);
            // }

            const manager = getManager();

            const query =  `select ac.asset_code as assetCode,ac.duration_one as durationOne,ac.duration_two as durationTwo,ac.tub_status as tubStatus,ac.asset_status as assetStatus,created_at as createdAt,tub_code as tubCode from `  + appSettings.assets_db + `.asset_action_control ac where ac.tub_status = 1 order by ac.created_at ASC`
            const data = await manager.query(query);
            if(data){
                return new CommonResponse(true,1111,'Data retreived sucessfully',data)
            }else{
                return new CommonResponse(false,1111,'No data ')

            }
        }catch(err){
            return new CommonResponse(true,2222,'Something Went Wrong')
        }
      }

      async stopAssets(reqObj: AssetControlRequest):Promise<CommonResponse>{
        try{
            let updateStatus
            if(reqObj.qrCodeType == 'assetCode'){
                updateStatus = await this.assetsRepository.update({assetsActionControlId:reqObj.assetsActionControlId},{assetStatus:false})
            }
            if(reqObj.qrCodeType == 'tubCode'){
                updateStatus = await this.assetsRepository.update({assetsActionControlId:reqObj.assetsActionControlId},{tubStatus:false})
            }
            if(updateStatus){
                return new CommonResponse(true,2222,'machine Stopped Successfuly')
            }else{
                return new CommonResponse(true,2222,'Something Went Wrong')
            }
        }catch(err){
            return new CommonResponse(true,2222,'Something Went Wrong')
        }
    }

    async assetActiveSoaking(): Promise<CommonResponse> {
        const manager = getManager()
        let query = `SELECT asset_action_control_id AS assetActionControlId , asset_code AS assetCode , cron_job_time AS cronJobTime ,asset_control AS assetControl , tub_code AS tubCode , duration_one AS durationOne , 
        duration_two AS durationTwo , tub_status AS tubStatus , asset_status AS assetStatus,created_at as stratTime    FROM  ` + appSettings.assets_db + `.asset_action_control where NOT(tub_status = 0 and asset_status = 0) `;
        const data = await manager.query(query);
        if (data) {
          const repo = new CommonResponse(true, 1141, 'Data retrieved successfully', data)
          const newLogDto = new LogsDto(1,'view', 'AssetsActionControl', 0, true, '','')
          let res = await this.logService.createLog(newLogDto);
          console.log(res);
          return repo
        } else {
          return new CommonResponse(false, 1121, 'No data')
        }
      }

   
      }

